import { BDCPBookmarksDetailsComponent } from './pages/details/details.page';
import { BDCPBookmarksRootComponent } from './pages/root/root.page';
import { BDCPSharedModule } from '../shared/shared.module';
import { BDSharedModule } from '@brother-apps/brother-dealerapp-shared-lib';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        BDCPSharedModule,
        BDSharedModule
    ],
    declarations: [
        BDCPBookmarksRootComponent,
        BDCPBookmarksDetailsComponent
    ],
    providers: [
    ],
    exports: [
        BDCPBookmarksRootComponent,
        BDCPBookmarksDetailsComponent
    ]
})
export class BDCPBookmarksModule { }
